import { cn } from "@/utils/helper";

export default function Icon({
  icon,
  size,
  backgroundClassName,
}: {
  icon: React.ReactNode;
  size?: number;
  backgroundClassName?: string;
}) {
  return (
    <div
      className={cn(
        `flex flex-shrink-0 items-center justify-center rounded-lg`,
        backgroundClassName,
      )}
      style={{ width: size ?? 40, height: size ?? 40 }}
    >
      {icon}
    </div>
  );
}
